import { Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TablePagination, TableRow } from "@mui/material";
import React, { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import Home from "../../home/Home";
import { getDate } from "../../Utils/Common";
import { useEffect } from "react";
import Snackbar from '../../Snacbar'
import FundReportService from "../../../Services/Reports/FundReportService";
import HashLoader from "react-spinners/HashLoader";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: 'rgb(61, 195, 177)',
    color: 'black',
    textAlign: "center",
  },
  [`&.${tableCellClasses.body}`]: {
    textAlign: "center",
    fontSize: 14,
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));
const ItemPap = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  border: '1px solid black',
  height: "100%",
}));
const ItemPap1 = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  backgroundColor: "white",
  border: '1px solid black',
  height: "100%",
}));

function FundStatus() {
  const mystyle = {
    border: " 1px solid black",
    width: "9rem",fontFamily: 'Times New Roman',
  };
  const mystyle1 = {
    fontWeight: "bolder",
    color: "#0b64c5",fontFamily: 'Times New Roman',
  };

  const [message, setMessage] = useState('');
  const [open, setOpen] = useState(false);
  const [severit, setseverit] = useState('');
  const [loading, setloading] = useState(false)
  const [showProcs, setshowProcs] = useState(false)
  const [exportExcelProcs, setexportExcelProcs] = useState(false)
  const [FilteredDetails, setFilteredDetails] = useState([])
  const [details1, setdetails1] = useState([]);
  const [details2, setdetails2] = useState([]);
  const [fndstatus, setfndstatus] = useState({
    from: getDate(),
    to: getDate(),
    status: '-1',
  });
  const fromhandlechange = (e) => {
    setfndstatus({ ...fndstatus, from: e.target.value })
  };
  const tohandlechange = (e) => {
    setfndstatus({ ...fndstatus, to: e.target.value })
  };
  const statushandlechange = (e) => {
    setfndstatus({ ...fndstatus, status: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };

  //error message
  const handleClose = () => {
    setOpen(false)
  }
  //getfunctions
  const getFundStatus = () => {
    FundReportService.getFundStatus().then(res => {
      setdetails1(res.data);
    })
  }
  ///
  const ShowBtnClick = () => {
    setshowProcs(true)
    setloading(true)
    setPage(0)
    let details = { fromDate: fndstatus.from, toDate: fndstatus.to, status: fndstatus.status }
    FundReportService.getFundStatusReport(details).then((res) => {
      const data = res.data;
      const details = data.map((item) => item);
      if (details[0] === [] || !details[0]) {
        setMessage('No Data Found!!')
        setseverit('warning')
        setOpen(true)
        setshowProcs(false)
        setloading(false)
      } else {
        setdetails2(res.data)
        setFilteredDetails(res.data)
        setshowProcs(false)
        setloading(false)
      }
    })
  }
  const ExportXlBtnClick = () => {
    setexportExcelProcs(true)
    if (details2[0] === [] || !details2[0]) {
      setMessage('No Record Found');
      setseverit('warning')
      setOpen(true)
    } else {
      console.log('else')
      var tableContent, contenall = '';
      for (let i = 0; i < details2.length; i++) {
        if (details2[i].consignmentNumber !== '') {
          tableContent = details2[i].consignmentNumber + "!"
        } else {
          tableContent += '   !'
        }
        if (details2[i].vendorName !== '') {
          tableContent += details2[i].vendorName + "!"
        }
        else {
          tableContent += '  !';
        }
        if (details2[i].clientName !== '') {
          tableContent += details2[i].clientName + "!"
        } else {
          tableContent += '  !';
        }
        if (details2[i].reqPurpose !== '') {
          tableContent += details2[i].reqPurpose + "!"
        } else {
          tableContent += '  !';
        }
        if (details2[i].reqAmount !== '') {
          tableContent += details2[i].reqAmount + "!"
        } else {
          tableContent += '  !';
        }
        if (details2[i].reqMode !== '') {
          tableContent += details2[i].reqMode + "!"
        } else {
          tableContent += '  !';
        }
        if (details2[i].reqDate !== '') {
          tableContent += details2[i].reqDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details2[i].reqName !== '') {
          tableContent += details2[i].reqName + "!"
        } else {
          tableContent += '  !';
        }
        if (details2[i].reqRemarks !== '') {
          tableContent += details2[i].reqRemarks + "!"
        } else {
          tableContent += '  !';
        }
        if (details2[i].approvalAmunt !== '') {
          tableContent += details2[i].approvalAmunt + "!"
        } else {
          tableContent += '  !';
        }
        if (details2[i].appMode !== '') {
          tableContent += details2[i].appMode + "!"
        } else {
          tableContent += '  !';
        }
        if (details2[i].approvalDate !== '') {
          tableContent += details2[i].approvalDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details2[i].appName !== '') {
          tableContent += details2[i].appName + "!"
        } else {
          tableContent += '  !';
        }
        if (details2[i].approvalRemarks !== '') {
          tableContent += details2[i].approvalRemarks + "!"
        } else {
          tableContent += '  !';
        }
        if (details2[i].firstLevelAmount !== '') {
          tableContent += details2[i].firstLevelAmount + "!"
        } else {
          tableContent += '  !';
        }
        if (details2[i].firstMode !== '') {
          tableContent += details2[i].firstMode + "!"
        } else {
          tableContent += '  !';
        }
        if (details2[i].firstLevelDate !== '') {
          tableContent += details2[i].firstLevelDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details2[i].firstLevelName !== '') {
          tableContent += details2[i].firstLevelName + "!"
        } else {
          tableContent += '  !';
        }
        if (details2[i].firstRemarks !== '') {
          tableContent += details2[i].firstRemarks + "!"
        } else {
          tableContent += '  !';
        }
        if (details2[i].secondLevelAmount !== '') {
          tableContent += details2[i].secondLevelAmount + "!"
        } else {
          tableContent += '  !';
        }
        if (details2[i].secondMode !== '') {
          tableContent += details2[i].secondMode + "!"
        } else {
          tableContent += '  !';
        }
        if (details2[i].secondLevelVeryDate !== '') {
          tableContent += details2[i].secondLevelVeryDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details2[i].secondLevelName !== '') {
          tableContent += details2[i].secondLevelName + "!"
        } else {
          tableContent += '  !';
        }
        if (details2[i].secondRemarks !== '') {
          tableContent += details2[i].secondRemarks + "!"
        } else {
          tableContent += '  !';
        }
        if (details2[i].allocatedAmount !== '') {
          tableContent += details2[i].allocatedAmount + "!"
        } else {
          tableContent += '  !';
        }
        if (details2[i].allocatedMode !== '') {
          tableContent += details2[i].allocatedMode + "!"
        } else {
          tableContent += '  !';
        }
        if (details2[i].allocatedDate !== '') {
          tableContent += details2[i].allocatedDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details2[i].allocatedName !== '') {
          tableContent += details2[i].allocatedName + "!"
        } else {
          tableContent += '  !';
        }
        if (details2[i].allocatedRemarks !== '') {
          tableContent += details2[i].allocatedRemarks + "!"
        } else {
          tableContent += '  !';
        }
        if (details2[i].releaseAmount !== '') {
          tableContent += details2[i].releaseAmount + "!"
        } else {
          tableContent += '  !';
        }
        if (details2[i].releaseMode !== '') {
          tableContent += details2[i].releaseMode + "!"
        } else {
          tableContent += '  !';
        }
        if (details2[i].release_date !== '') {
          tableContent += details2[i].release_date + "!"
        } else {
          tableContent += '  !';
        }
        if (details2[i].releaseName !== '') {
          tableContent += details2[i].releaseName + "!"
        } else {
          tableContent += '  !';
        }
        if (details2[i].releaseRemarks !== '') {
          tableContent += details2[i].releaseRemarks + "#"
        } else {
          tableContent += '  #';
        }
        contenall += tableContent;
      }
      let details = {
        headerName: "3,0,FUND STATUS REPORT", headerDetails: "1,1,FROM DATE : " + fndstatus.from + "/4,1,TO DATE : " + fndstatus.to,
        tableHeader: "0,3,Sl.No/1,3,Job No/2,3,Vendor Name/3,3,Client Name/4,3,Description/5,3,Request Amount/6,3,Request Mode/7,3,Request Date/8,3,Request By/9,3,Request Remarks/10,3,Approval Amount/11,3,Approval Mode/12,3,Approval Date/13,3,Approval By/14,3,Approval Remarks/15,3,1stLevel Amount/16,3,1stLevel Mode/17,3,1stLevel Date/18,3,1stLevel By/19,3,1stLevel Remarks/20,3,2ndLevel Amount/21,3,2ndLevel Mode/22,3,2ndLevel Date/23,3,2ndLevel By/24,3,2ndLevel Remarks/25,3,Allocated Amount/26,3,Allocated Mode/27,3,Allocated Date/28,3,Allocated By/29,3,Allocated Remarks/30,3,Release Amount/31,3,Release Mode/32,3,Release Date/33,3,Release By/34,3,Release Remarks",
        tableRowStartsFrom: 4, tableColumnStartsFrom: 0, fileCode: "FundStatus", totalNumberOfColumn: 35, tableContent: contenall.substring(0, contenall.length - 1)
      }
      FundReportService.Excelwrite(details).then((res) => {
        const filename = res.data.message;
        // window.open('http://localhost:8080/ExportFiles/' + filename.toString(), "_blank")
        window.open('http://35.154.221.117:8081/ExportFiles/' + filename.toString(), "_blank");

      })
    }
    setexportExcelProcs(false)
  }
  ///
  useEffect(() => {
    setloading(true)
    setTimeout(() => {
      setloading(false)
    }, 1000)
    getFundStatus()
  }, []);

  //table Search
  const jobNmSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search" onChange={(e) => { jobNoOnchange(e.target.value) }} />
  }
  const vendorNmSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search" onChange={(e) => { vendorNmOnchange(e.target.value) }} />
  }
  const rqstMdSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search" onChange={(e) => { rqstMdOnchange(e.target.value) }} />
  }
  const rqstBySrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search" onChange={(e) => { rqstByOnchange(e.target.value) }} />
  }
  const aprvlBySrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search" onChange={(e) => { aprvlByOnchange(e.target.value) }} />
  }
  const releaseBySrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search" onChange={(e) => { releaseByOnchange(e.target.value) }} />
  }
  //
  const jobNoOnchange = (searchedVal) => {
    const filteredvalue = details2.filter((trns) => {
      return trns.consignmentNumber.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details2)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const vendorNmOnchange = (searchedVal) => {
    const filteredvalue = details2.filter((trns) => {
      return trns.vendorName.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details2)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const rqstMdOnchange = (searchedVal) => {
    const filteredvalue = details2.filter((trns) => {
      return trns.reqMode.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details2)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const rqstByOnchange = (searchedVal) => {
    const filteredvalue = details2.filter((trns) => {
      return trns.reqName.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details2)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const aprvlByOnchange = (searchedVal) => {
    const filteredvalue = details2.filter((trns) => {
      return trns.appName.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details2)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const releaseByOnchange = (searchedVal) => {
    const filteredvalue = details2.filter((trns) => {
      return trns.releaseName.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details2)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  //paginationCodes

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }

  return (
    <div>
      <Home />
      <div style={{ paddingLeft: '100px' }}>
        <Snackbar open={open} message={message} severity={severit} onClose={handleClose} />
        {loading ?
          <div className="loaderCss">
            <HashLoader
              color={"#296cbc"}
              loading={loading}
              size={50}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </div>
          :
          <ItemPap>
            <div className='Billingtitleclr' style={{ color: 'red', fontWeight: 'bold', fontSize: '25px', marginTop: '1%', marginBottom: '1%', }}><center>FUND STATUS REPORT</center></div>
            <Row>
              <Col></Col>
              <Col></Col>
              <Col>
                <label style={mystyle1}>FromDate</label>
              </Col>
              <Col>
                <Form.Control size="sm" type="date" style={mystyle} value={fndstatus.from} onChange={fromhandlechange} />
              </Col>
              <Col>
                <label style={mystyle1}>ToDate</label>
              </Col>
              <Col>
                <Form.Control size="sm" type="date" style={mystyle} value={fndstatus.to} onChange={tohandlechange} />
              </Col>
              <Col>
                <label style={mystyle1}>FundStatus</label>
              </Col>
              <Col>
                <Form.Select size="sm" style={mystyle} value={fndstatus.status} onChange={statushandlechange}>
                  <option value={'-1'}>ALL</option>
                  {details1.map(trns => (
                    <option value={trns.requestStatus}>{trns.requestStatus}</option>
                  ))}
                </Form.Select>
              </Col>
              <Col></Col>
              <Col></Col>
            </Row>
            <br></br>
            <Row className="mb-1">
              <Col lg={4}></Col>
              <Col lg={4}>
                <Button style={{ fontFamily: 'Times New Roman'}}variant="primary" size="sm" onClick={ShowBtnClick}>{showProcs ? 'processing...' : 'Show'}</Button>
                &nbsp;
                <Button style={{ fontFamily: 'Times New Roman'}}variant="success" size="sm" onClick={ExportXlBtnClick}>{exportExcelProcs ? 'processing...' : 'Export Excel'}</Button>
              </Col>
              <Col lg={4}></Col>
            </Row>
            <ItemPap1>
              <TableContainer sx={{ height: 460 }} className="mt-1">
                <Table stickyHeader className="table table-bordered">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell>SlNo</StyledTableCell>
                      <StyledTableCell>JobNo {jobNmSrch()}</StyledTableCell>
                      <StyledTableCell>VendorName{vendorNmSrch()}</StyledTableCell>
                      <StyledTableCell>ClientName</StyledTableCell>
                      <StyledTableCell>Description</StyledTableCell>
                      <StyledTableCell>RequestAmount</StyledTableCell>
                      <StyledTableCell>RequestMode{rqstMdSrch()}</StyledTableCell>
                      <StyledTableCell>RequestDate</StyledTableCell>
                      <StyledTableCell>RequestBy{rqstBySrch()}</StyledTableCell>
                      <StyledTableCell>RequestRemark</StyledTableCell>
                      <StyledTableCell>ApprovalAmount</StyledTableCell>
                      <StyledTableCell>ApprovalMode</StyledTableCell>
                      <StyledTableCell>ApprovalDate</StyledTableCell>
                      <StyledTableCell>ApprovalBy {aprvlBySrch()}</StyledTableCell>
                      <StyledTableCell>ApprovalRemark</StyledTableCell>
                      <StyledTableCell>1stLevelVrfyAmount</StyledTableCell>
                      <StyledTableCell>1stLevelVrfyMode</StyledTableCell>
                      <StyledTableCell>1stLevelVrfyDate</StyledTableCell>
                      <StyledTableCell>1stLevelVrfyBy</StyledTableCell>
                      <StyledTableCell>1stLevelVrfyRemark</StyledTableCell>
                      <StyledTableCell>2ndLevelVrfyAmount</StyledTableCell>
                      <StyledTableCell>2ndLevelVrfyMode</StyledTableCell>
                      <StyledTableCell>2ndLevelVrfyDate</StyledTableCell>
                      <StyledTableCell>2ndLevelVrfyBy</StyledTableCell>
                      <StyledTableCell>2ndLevelVrfyRemark</StyledTableCell>
                      <StyledTableCell>AllocatedAmount</StyledTableCell>
                      <StyledTableCell>AllocatedMode</StyledTableCell>
                      <StyledTableCell>AllocatedDate</StyledTableCell>
                      <StyledTableCell>AllocatedBy</StyledTableCell>
                      <StyledTableCell>AllocatedRemark</StyledTableCell>
                      <StyledTableCell>ReleaseAmount</StyledTableCell>
                      <StyledTableCell>ReleaseMode</StyledTableCell>
                      <StyledTableCell>ReleaseDate</StyledTableCell>
                      <StyledTableCell>ReleaseBy{releaseBySrch()}</StyledTableCell>
                      <StyledTableCell>ReleaseRemark</StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {FilteredDetails.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((trns, index) => (
                        <TableRow hover key={trns.serialNumber}>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.serialNumber}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.consignmentNumber}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.vendorName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.clientName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.reqPurpose}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.reqAmount}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.reqMode}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.reqDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.reqName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.reqRemarks}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.approvalAmunt}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.appMode}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.approvalDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.appName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.approvalRemarks}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.firstLevelAmount}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.firstMode}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.firstLevelDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.firstLevelName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.firstRemarks}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.secondLevelAmount}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.secondMode}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.secondLevelVeryDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.secondLevelName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.secondRemarks}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.allocatedAmount}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.allocatedMode}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.allocatedDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.allocatedName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.allocatedRemarks}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.releaseAmount}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.releaseMode}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.release_date}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.releaseName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.releaseRemarks}</StyledTableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                showFirstButton
                showLastButton
                component='div'
                count={FilteredDetails.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onChangeRowsPerpage={handleChangeRowsPerPage}
              />
            </ItemPap1>
          </ItemPap>}
      </div>
    </div>
  );
}

export default FundStatus;
